<template>
  <div class="bl">
    <div class="bl-topbar">
      <div class="bl-topbar-left">
        <h5>Blog</h5>
        <span class="bl-count" v-if="total">{{ total }} posts</span>
      </div>
      <div class="bl-topbar-actions">
        <button class="bl-btn bl-btn-ghost" @click="showCategorias = true">
          <feather-icon icon="TagIcon" size="14" />
          Categorias
        </button>
        <button class="bl-btn bl-btn-primary" @click="$router.push({ name: 'app-blog-novo' })">
          <feather-icon icon="PlusIcon" size="14" />
          Novo Post
        </button>
      </div>
    </div>

    <div class="bl-filters">
      <div class="bl-search">
        <feather-icon icon="SearchIcon" size="14" class="bl-search-icon" />
        <input v-model="searchQuery" placeholder="Buscar posts..." class="bl-search-input" @input="debounceFetch" />
      </div>
      <select v-model="statusFilter" class="bl-select" @change="fetchPosts">
        <option value="">Todos os status</option>
        <option value="rascunho">Rascunho</option>
        <option value="pendente_aprovacao">Pendente</option>
        <option value="publicado">Publicado</option>
        <option value="arquivado">Arquivado</option>
      </select>
      <select v-model="categoriaFilter" class="bl-select" @change="fetchPosts">
        <option value="">Todas categorias</option>
        <option v-for="cat in categorias" :key="cat.id" :value="cat.id">{{ cat.nome }}</option>
      </select>
    </div>

    <div class="bl-card">
      <div v-if="loading" class="bl-loading">
        <b-spinner variant="primary" />
      </div>
      <div v-else-if="!posts.length" class="bl-empty">
        <feather-icon icon="FileTextIcon" size="40" />
        <h6>Nenhum post encontrado</h6>
        <p>Crie seu primeiro artigo clicando em "Novo Post"</p>
      </div>
      <table v-else class="bl-table">
        <thead>
          <tr>
            <th class="col-cover"></th>
            <th>Título</th>
            <th>Categoria</th>
            <th>Status</th>
            <th>Views</th>
            <th>Criado</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="post in posts" :key="post.id" @click="editPost(post)" class="bl-row">
            <td>
              <img v-if="post.imagem_destaque" :src="post.imagem_destaque" class="bl-cover" />
              <div v-else class="bl-cover-ph"><feather-icon icon="ImageIcon" size="14" /></div>
            </td>
            <td>
              <div class="bl-title-cell">
                <strong>{{ post.titulo }}</strong>
                <span>{{ post.slug }}</span>
              </div>
            </td>
            <td>
              <span v-if="post.categoria" class="bl-cat" :style="{ backgroundColor: post.categoria.cor + '18', color: post.categoria.cor, borderColor: post.categoria.cor + '30' }">
                {{ post.categoria.nome }}
              </span>
              <span v-else class="bl-no-cat">—</span>
            </td>
            <td>
              <span class="bl-status" :class="'st-' + statusVariant(post.status)">
                {{ statusLabel(post.status) }}
              </span>
            </td>
            <td>
              <span class="bl-views"><feather-icon icon="EyeIcon" size="13" /> {{ post.visualizacoes || 0 }}</span>
            </td>
            <td>
              <span class="bl-date">{{ formatDate(post.data_inclusao) }}</span>
            </td>
            <td>
              <div class="bl-actions" @click.stop>
                <button class="bl-act edit" @click="editPost(post)" title="Editar"><feather-icon icon="EditIcon" size="14" /></button>
                <button class="bl-act del" @click="confirmDelete(post)" title="Excluir"><feather-icon icon="TrashIcon" size="14" /></button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="bl-footer" v-if="posts.length">
        <span class="bl-total">{{ total }} post(s)</span>
        <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" size="sm" @change="onPageChange" class="bl-pager mb-0" />
      </div>
    </div>

    <b-modal v-model="showCategorias" title="Categorias do Blog" size="lg" hide-footer modal-class="bl-cat-modal">
      <div class="bl-cat-form">
        <input v-model="newCat.nome" placeholder="Nome" class="bl-input" />
        <input v-model="newCat.slug" placeholder="slug" class="bl-input" />
        <input v-model="newCat.cor" type="color" class="bl-color" />
        <button class="bl-btn bl-btn-primary bl-btn-sm" @click="salvarCategoria">
          {{ editingCat ? 'Atualizar' : 'Criar' }}
        </button>
      </div>
      <b-table :items="categorias" :fields="catFields" responsive hover small class="bl-cat-table mt-2">
        <template #cell(cor)="data">
          <div class="bl-cat-dot" :style="{ backgroundColor: data.value }" />
        </template>
        <template #cell(acoes)="data">
          <div class="bl-actions">
            <button class="bl-act edit" @click="editCategoria(data.item)"><feather-icon icon="EditIcon" size="14" /></button>
            <button class="bl-act del" @click="deleteCategoria(data.item)"><feather-icon icon="TrashIcon" size="14" /></button>
          </div>
        </template>
      </b-table>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BTable, BButton, BBadge, BPagination,
  BRow, BCol, BFormInput, BFormSelect, BSpinner, BModal,
} from 'bootstrap-vue'

export default {
  components: {
    BCard, BCardHeader, BCardBody, BTable, BButton, BBadge, BPagination,
    BRow, BCol, BFormInput, BFormSelect, BSpinner, BModal,
  },
  data() {
    return {
      posts: [],
      categorias: [],
      loading: false,
      searchQuery: '',
      statusFilter: '',
      categoriaFilter: '',
      currentPage: 1,
      perPage: 10,
      total: 0,
      searchTimeout: null,
      fields: [
        { key: 'imagem_destaque', label: 'Capa', sortable: false },
        { key: 'titulo', label: 'Título', sortable: true },
        { key: 'categoria', label: 'Categoria', sortable: false },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'visualizacoes', label: 'Views', sortable: true },
        { key: 'data_inclusao', label: 'Criado em', sortable: true },
        { key: 'acoes', label: 'Ações', sortable: false },
      ],
      showCategorias: false,
      newCat: { nome: '', slug: '', cor: '#F26522' },
      editingCat: null,
      catFields: [
        { key: 'cor', label: 'Cor', sortable: false },
        { key: 'nome', label: 'Nome', sortable: true },
        { key: 'slug', label: 'Slug', sortable: false },
        { key: 'acoes', label: 'Ações', sortable: false },
      ],
    }
  },
  created() {
    if (!this.$store.hasModule('blog')) {
      this.$store.registerModule('blog', require('./blogStoreModule').default)
    }
    this.$nextTick(() => {
      this.fetchPosts()
      this.fetchCategorias()
    })
  },
  methods: {
    async fetchPosts() {
      this.loading = true
      try {
        const { data } = await this.$store.dispatch('blog/fetchPosts', {
          page: this.currentPage,
          limit: this.perPage,
          search: this.searchQuery || undefined,
          status: this.statusFilter || undefined,
          id_categoria: this.categoriaFilter || undefined,
        })
        this.posts = data.posts
        this.total = data.total
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    async fetchCategorias() {
      try {
        const { data } = await this.$store.dispatch('blog/fetchCategorias')
        this.categorias = data
      } catch (e) {
        console.error(e)
      }
    },
    debounceFetch() {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1
        this.fetchPosts()
      }, 400)
    },
    onPageChange(page) {
      this.currentPage = page
      this.fetchPosts()
    },
    editPost(item) {
      this.$router.push({ name: 'app-blog-editar', params: { id: item.id } })
    },
    async confirmDelete(item) {
      const ok = await this.$bvModal.msgBoxConfirm(`Deseja excluir "${item.titulo}"?`, {
        title: 'Confirmar Exclusão',
        okVariant: 'danger',
        okTitle: 'Excluir',
        cancelTitle: 'Cancelar',
      })
      if (ok) {
        await this.$store.dispatch('blog/deletePost', item.id)
        this.fetchPosts()
      }
    },
    async salvarCategoria() {
      const slug = this.newCat.slug || this.newCat.nome.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')
      const payload = { ...this.newCat, slug }
      if (this.editingCat) {
        await this.$store.dispatch('blog/updateCategoria', { id: this.editingCat.id, data: payload })
      } else {
        await this.$store.dispatch('blog/createCategoria', payload)
      }
      this.newCat = { nome: '', slug: '', cor: '#F26522' }
      this.editingCat = null
      this.fetchCategorias()
    },
    editCategoria(item) {
      this.editingCat = item
      this.newCat = { nome: item.nome, slug: item.slug, cor: item.cor }
    },
    async deleteCategoria(item) {
      await this.$store.dispatch('blog/deleteCategoria', item.id)
      this.fetchCategorias()
    },
    statusVariant(s) {
      if (s === 'publicado') return 'success'
      if (s === 'pendente_aprovacao') return 'info'
      if (s === 'arquivado') return 'muted'
      return 'warning'
    },
    statusLabel(s) {
      if (s === 'publicado') return 'Publicado'
      if (s === 'pendente_aprovacao') return 'Pendente'
      if (s === 'arquivado') return 'Arquivado'
      return 'Rascunho'
    },
    formatDate(d) {
      if (!d) return '—'
      return new Date(d).toLocaleDateString('pt-BR')
    },
  },
}
</script>

<style scoped>
*{box-sizing:border-box}
.bl{font-family:Inter,-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;color:#1a1a2e}

.bl-topbar{display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;flex-wrap:wrap;gap:12px}
.bl-topbar-left{display:flex;align-items:center;gap:10px}
.bl-topbar-left h5{font-size:1.3rem;font-weight:800;margin:0;color:#1a1a2e}
.bl-count{font-size:.75rem;font-weight:600;color:#94a3b8;background:#f1f5f9;padding:3px 10px;border-radius:20px}

.bl-topbar-actions{display:flex;gap:8px}
.bl-btn{display:inline-flex;align-items:center;gap:6px;padding:8px 16px;border-radius:10px;font-size:.82rem;font-weight:600;border:none;cursor:pointer;transition:all .2s cubic-bezier(.4,0,.2,1);white-space:nowrap}
.bl-btn-ghost{background:#fff;color:#64748b;border:1px solid #e2e8f0}
.bl-btn-ghost:hover{background:#f8fafc;color:#475569;border-color:#cbd5e1}
.bl-btn-primary{background:#7c3aed;color:#fff}
.bl-btn-primary:hover{background:#6d28d9;box-shadow:0 4px 14px rgba(124,58,237,.3);transform:translateY(-1px)}
.bl-btn-sm{padding:6px 12px;font-size:.78rem;border-radius:8px}

.bl-filters{display:flex;gap:10px;margin-bottom:16px;flex-wrap:wrap}
.bl-search{position:relative;flex:1;min-width:200px}
.bl-search-icon{position:absolute;left:12px;top:50%;transform:translateY(-50%);color:#94a3b8}
.bl-search-input{width:100%;padding:9px 14px 9px 36px;border:1.5px solid #e2e8f0;border-radius:10px;font-size:.85rem;color:#1a1a2e;background:#fff;outline:none;transition:all .2s;font-family:inherit}
.bl-search-input:focus{border-color:#7c3aed;box-shadow:0 0 0 3px rgba(124,58,237,.1)}
.bl-search-input::placeholder{color:#94a3b8}
.bl-select{padding:9px 32px 9px 12px;border:1.5px solid #e2e8f0;border-radius:10px;font-size:.85rem;color:#475569;background:#fff;outline:none;appearance:none;background-image:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");background-position:right 8px center;background-repeat:no-repeat;background-size:18px;cursor:pointer;min-width:150px;font-family:inherit;transition:all .2s}
.bl-select:focus{border-color:#7c3aed;box-shadow:0 0 0 3px rgba(124,58,237,.1)}

.bl-card{background:#fff;border:1px solid #e2e8f0;border-radius:14px;overflow:hidden;box-shadow:0 1px 3px rgba(0,0,0,.04)}

.bl-loading{display:flex;align-items:center;justify-content:center;padding:60px}
.bl-empty{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:60px 20px;color:#94a3b8}
.bl-empty h6{margin:12px 0 4px;color:#475569;font-weight:600}
.bl-empty p{font-size:.85rem;margin:0}

.bl-table{width:100%;border-collapse:collapse}
.bl-table thead th{padding:12px 16px;font-size:.72rem;font-weight:700;text-transform:uppercase;letter-spacing:.6px;color:#94a3b8;border-bottom:1px solid #f1f5f9;text-align:left;background:#fafbfc}
.bl-table thead th.col-cover{width:70px}
.bl-table tbody td{padding:14px 16px;border-bottom:1px solid #f8fafc;vertical-align:middle}
.bl-row{cursor:pointer;transition:background .15s}
.bl-row:hover{background:#faf5ff}

.bl-cover{width:64px;height:40px;border-radius:8px;object-fit:cover;border:1px solid #e2e8f0}
.bl-cover-ph{width:64px;height:40px;border-radius:8px;background:#f1f5f9;display:flex;align-items:center;justify-content:center;color:#cbd5e1}

.bl-title-cell{display:flex;flex-direction:column;gap:2px}
.bl-title-cell strong{font-size:.88rem;color:#1a1a2e;font-weight:600}
.bl-title-cell span{font-size:.72rem;color:#94a3b8}

.bl-cat{font-size:.72rem;font-weight:600;padding:3px 10px;border-radius:6px;border:1px solid;display:inline-block}
.bl-no-cat{color:#cbd5e1}

.bl-status{font-size:.72rem;font-weight:700;padding:4px 10px;border-radius:20px;display:inline-block}
.bl-status.st-success{background:#ecfdf5;color:#10b981}
.bl-status.st-warning{background:#fffbeb;color:#f59e0b}
.bl-status.st-info{background:#eff6ff;color:#3b82f6}
.bl-status.st-muted{background:#f1f5f9;color:#94a3b8}

.bl-views{display:flex;align-items:center;gap:4px;color:#94a3b8;font-size:.82rem}
.bl-date{color:#94a3b8;font-size:.82rem}

.bl-actions{display:flex;gap:2px}
.bl-act{width:32px;height:32px;border-radius:8px;border:none;background:transparent;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:all .2s}
.bl-act.edit{color:#7c3aed}
.bl-act.edit:hover{background:#f5f3ff}
.bl-act.del{color:#ef4444}
.bl-act.del:hover{background:#fef2f2}

.bl-footer{display:flex;justify-content:space-between;align-items:center;padding:12px 16px;border-top:1px solid #f1f5f9}
.bl-total{font-size:.78rem;color:#94a3b8}
.bl-pager >>> .page-link{border-radius:8px;margin:0 2px;border:none;color:#475569;font-weight:500}
.bl-pager >>> .page-item.active .page-link{background:#7c3aed;color:#fff}

.bl-input{padding:8px 12px;border:1.5px solid #e2e8f0;border-radius:8px;font-size:.85rem;outline:none;flex:1;min-width:100px;font-family:inherit}
.bl-input:focus{border-color:#7c3aed;box-shadow:0 0 0 3px rgba(124,58,237,.1)}
.bl-color{width:36px;height:36px;border:1.5px solid #e2e8f0;border-radius:8px;padding:2px;cursor:pointer}
.bl-cat-form{display:flex;gap:8px;align-items:center;flex-wrap:wrap}
.bl-cat-dot{width:22px;height:22px;border-radius:6px;border:1px solid rgba(0,0,0,.08)}
.bl-cat-table >>> thead th{font-size:.75rem;font-weight:600;color:#94a3b8;text-transform:uppercase;letter-spacing:.5px}
</style>
